export default "__VITE_ASSET__T41SmTts__"